module.exports = __webpack_public_path__ + "img/arrow-right.a759fb82.svg";